import { render } from "./UserSolutions.vue?vue&type=template&id=5c1a85cb&scoped=true"
import script from "./UserSolutions.vue?vue&type=script&lang=js"
export * from "./UserSolutions.vue?vue&type=script&lang=js"

import "./UserSolutions.vue?vue&type=style&index=0&id=5c1a85cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1a85cb"]])

export default __exports__